// Dashboard.js — Boas-vindas + KPIs (por perfil).
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_URL from './config';
import './Dashboard.css';

function Dashboard({ username, userRole }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const isAdmin = userRole === 'admin';

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_URL}/dashboard`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setData(r.data))
      .catch((e) => setError(e.response?.data?.message || e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="dashboard-container">
      <h1 className="welcome-message">Bem-vindo, {username}!</h1>
      <p className="subtitle">Visão geral do sistema.</p>

      {error && <div className="message messageError">{error}</div>}
      {loading && <div className="loadingMessage">Carregando indicadores...</div>}

      {data && (
        <>
          <div className="kpi-group">
            <h2 className="kpi-group-title">Chamadas de hoje</h2>
            <div className="kpi-grid">
              {data.chamadasHoje ? (
                <>
                  <div className="kpi-card">
                    <div className="kpi-label">Chamadas hoje</div>
                    <div className="kpi-value">{data.chamadasHoje.total}</div>
                    <div className="kpi-sub">PBX: {data.chamadasHoje.servidor || '-'}</div>
                  </div>
                  <div className="kpi-card kpi-success">
                    <div className="kpi-label">Atendidas</div>
                    <div className="kpi-value">{data.chamadasHoje.atendidas}</div>
                  </div>
                  <div className="kpi-card kpi-warning">
                    <div className="kpi-label">Abandonadas</div>
                    <div className="kpi-value">{data.chamadasHoje.abandonadas}</div>
                  </div>
                </>
              ) : (
                <div className="kpi-card kpi-muted">
                  <div className="kpi-label">Chamadas hoje</div>
                  <div className="kpi-value">—</div>
                </div>
              )}
            </div>
          </div>

          <div className="kpi-group">
            <h2 className="kpi-group-title">{isAdmin ? 'Sistema' : 'Ramais'}</h2>
            <div className="kpi-grid">
              {isAdmin ? (
                <>
                  <div className="kpi-card">
                    <div className="kpi-label">Servidores ativos</div>
                    <div className="kpi-value">{data.servidores}</div>
                  </div>
                  <div className="kpi-card">
                    <div className="kpi-label">Usuários</div>
                    <div className="kpi-value">{data.usuarios}</div>
                  </div>
                </>
              ) : (
                <>
                  <div className="kpi-card">
                    <div className="kpi-label">Quantidade de ramais</div>
                    <div className="kpi-value">{data.ramais ? data.ramais.length : 0}</div>
                  </div>
                  <div className="kpi-card">
                    <div className="kpi-label">Ramais desconectados</div>
                    <div className="kpi-value">{data.ramaisDeslogados != null ? data.ramaisDeslogados : '—'}</div>
                  </div>
                  <div className="kpi-card">
                    <div className="kpi-label">Ramal com maior latência</div>
                    <div className="kpi-value">
                      {data.ramalMaiorLatencia ? data.ramalMaiorLatencia.extension : '—'}
                    </div>
                    <div className="kpi-sub">
                      {data.ramalMaiorLatencia ? `${data.ramalMaiorLatencia.ms} ms` : ''}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Dashboard;
